/* global SideDrawer */

if (!customElements.get('vat-toggle')) {
  class VatToggle extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
    }
    connectedCallback() {
      const cookieValue = this.getCookie();
      this.checked = cookieValue === '' ? true : (cookieValue === 'true');
      this.classes();
      this.input.addEventListener('change', () => this.setCookie());
    }
    setCookie() {
      const date = new Date();
      // 28 day cookie, if this needs changed, change the first digit below
      date.setTime(date.getTime() + 28 * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + date.toUTCString();
      document.cookie =
        'vat_include' + '=' + this.input.checked + ';' + expires + ';path=/';
      this.checked = this.input.checked;
      this.classes();
    }
    getCookie() {
      const name = 'vat_include=';
      const cookieChips = document.cookie.split(';');
      for (let i = 0; i < cookieChips.length; i++) {
        let chip = cookieChips[i];
        while (chip.charAt(0) == ' ') {
          chip = chip.substring(1);
        }
        if (chip.indexOf(name) == 0) {
          return chip.substring(name.length, chip.length);
        }
      }
      return '';
    }
    classes() {
      if (this.checked === true || this.checked === 'true') {
        document.body.classList.add('vat--included');
        document.body.classList.remove('vat--excluded');
        this.input.checked = true;
      } else {
        document.body.classList.remove('vat--included');
        document.body.classList.add('vat--excluded');
        this.input.checked = false;
      }
    }
  }
  customElements.define('vat-toggle', VatToggle);
}